import Vue from 'vue';

export default Vue.mixin({
    methods: {
        removeEmptyStringOrObjectsFromArray(item) {
            for (var prop in item) {
                if (item.hasOwnProperty(prop) && Array.isArray(item[prop]) && item[prop].length) {
                    for (var i = 0; i < item[prop].length; i++) {
                        if (item[prop][i] === "" || this.isObjectEmpty(item[prop][i])) {
                            item[prop].splice(i, 1);
                        }
                    }
                }
                else if (typeof item[prop] === 'object' && item[prop] !== null) {
                    this.removeEmptyStringOrObjectsFromArray(item[prop]);
                }
            }
        },

        isObjectEmpty(obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    return false;
                }
            }

            return JSON.stringify(obj) === JSON.stringify({});
        },

        isEmpty(value) {
            return value === null || typeof value === "undefined";
        },
    }
})
